import { Paragraph, SelectPlaceholder } from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import classNames from "classnames";
import type {
  ConditionFieldDescription,
  ConditionsConfig_ConditionConfig,
} from "@smartsuite/automation-engine-api";
import type { ReactElement, RefObject } from "react";

export const ConditionSelectInput: React.FC<{
  openCondition: boolean;
  conditionFields: ConditionFieldDescription[];
  condition: ConditionsConfig_ConditionConfig;
  fieldDescription?: ConditionFieldDescription;
  handleClick: () => void;
  buttonRef: RefObject<HTMLDivElement>;
}> = ({
  openCondition,
  conditionFields,
  condition,
  fieldDescription,
  handleClick,
  buttonRef,
}) => {
  const conditionInputGroupClasses = classNames(
    "react-input-group",
    "react-input-group--white",
    {
      "is-default": !openCondition,
      "is-active": openCondition,
    },
  );

  const getLabel = (field?: ConditionFieldDescription): string => {
    if (!field) {
      return "";
    }
    const labelText = field.labelSuffix
      ? `${field.label}: ${field.labelSuffix}`
      : field.label;
    return labelText;
  };

  const selectedOptionRenderer = (): ReactElement => {
    return (
      <Paragraph wrapMode="ellipsis" color="currentColor">
        {getLabel(fieldDescription)}
      </Paragraph>
    );
  };

  return (
    <div className={conditionInputGroupClasses}>
      <div className="single-select single-select--type-regular">
        <div className="single-select__wrap">
          <div
            className={"single-select__placeholder"}
            role="presentation"
            ref={buttonRef}
            onClick={handleClick}
            onKeyDown={handleClick}
          >
            <SelectPlaceholder
              active={openCondition}
              options={conditionFields
                .filter(
                  (field) =>
                    field.conditionFieldId === condition.conditionFieldId,
                )
                .map((field) => ({
                  label: field.label,
                  value: field.conditionFieldId,
                }))}
              placeholder={
                openCondition ? t("automation-form.select-field") : "\u00a0"
              }
              placeholderArrowStyle="filled-dark"
              onClick={() => {}}
              type="regular"
              renderOption={selectedOptionRenderer}
              showClear={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
